export default __webpack_public_path__ + "static/media/trampapo_02_28.5ca143e3.jpg";